import navigareCompaniesApiService from '@/services/api/NavigareCompanies'

const emptyBankAccount = {
  iban: null,
  bank_name: null,
  bic: null,
  currency: 'EUR'
}

const emptyModel = {
  country_id: null,
  name: null,
  tax_id: null,
  bank_accounts: [
    emptyBankAccount
  ],
  contact_details: {
    email: null,
    telephone: null,
    address: null,
    delivery_address: null,
    city: null
  },
  representative_name: null,
  parent: false
}

const emptyFilters = {
  id: null,
  country_id: null,
  name: null
}

class NavigareCompany {
  constructor() {
    this.api = navigareCompaniesApiService
    this.emptyModel = emptyModel
    this.emptyBankAccount = emptyBankAccount
    this.emptyFilters = emptyFilters
  }
}

const navigareCompany = new NavigareCompany()

export default navigareCompany
